var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "curtainSlider";

var DEFAULTS = {
	itemSelector: '',
	controlArrows: true
};

// The actual plugin constructor
function CurtainSlider(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this.initialise_();
}

/**
 * init
 */
CurtainSlider.prototype.initialise_ = function() {
	this.reinitSlider();
	var self_ = this;
	$(window).on('resize.curtain.dragslider', function() {
		self_.reinitSlider();
	});
};

/**
 * new function to call - due to plugin recall by API
 */
CurtainSlider.prototype.reinitSlider = function() {
	this.leftOffset = 0;

	if (this.checkDimensions_()) {
		this.updateListDimensions_();
		this.renderControls_();
	} else {
		this.$t.animate({
			opacity: 1
		}, 200);
	}
};

CurtainSlider.prototype.checkDimensions_ = function() {
	this.$items = $(this.options.itemSelector, this.$t);
	this.itemWidth = this.$items.size() > 0 ? $(this.$items[0]).outerWidth(true) : 1;
	this.listWidth = this.$t.parent().width();
	this.contentWidth = 0;

	for (var i = 0; i < this.$items.length; i++) {
		this.contentWidth += $(this.$items[i]).outerWidth(true);
	}

	if (this.contentWidth < this.listWidth) {
		this.removeControls_();
		return false;
	}

	return true;
};

CurtainSlider.prototype.updateListDimensions_ = function() {
	//this.$t.width(this.contentWidth);
	this.$t.animate({ 'margin-left' : this.leftOffset + 'px' }, 150);
	if (this.$left instanceof $) {
		this.refreshControlArrows_();
		this.disableControlArrow_(this.$left);
	}
	this.$t.animate({
		opacity: 1
	}, 200);
};

CurtainSlider.prototype.renderControls_ = function() {

	if (this.$controls instanceof $) {
		return false;
	}

	this.$controls = $('<div class="curtain-dragslider controls"></div>').appendTo(this.$t.parent());
	this.$left = $('<span class="controls--left disabled" data-dir="-1"></span>').appendTo(this.$controls);
	this.$right = $('<span class="controls--right" data-dir="1"></span>').appendTo(this.$controls);

	this.bindControls_();
};

CurtainSlider.prototype.removeControls_ = function() {
	if (this.$controls instanceof $) {
		this.$controls.remove();
	}
};

CurtainSlider.prototype.bindControls_ = function() {
	var self_ = this;
	this.$left.on('click', self_.slideLeft_.bind(self_));
	this.$right.on('click', self_.slideRight_.bind(self_));
};

CurtainSlider.prototype.slideLeft_ = function() {
	console.log(this.itemWidth, this.listWidth, this.contentWidth);
	this.leftOffset = this.leftOffset + this.itemWidth;
	this.animateSlide_();
};

CurtainSlider.prototype.slideRight_ = function() {
	console.log(this.itemWidth, this.listWidth, this.contentWidth);
	this.leftOffset = this.leftOffset - this.itemWidth;
	this.animateSlide_();
};

CurtainSlider.prototype.animateSlide_ = function() {
	var leftOffset = this.leftOffset;
	this.refreshControlArrows_();
	if (leftOffset > 0) {
		leftOffset = 0;
		this.disableControlArrow_(this.$left);
	}

	if (Math.abs(leftOffset) > this.contentWidth - this.listWidth) {
		leftOffset =  -1*(this.contentWidth - this.listWidth);
		this.disableControlArrow_(this.$right);
	}

	this.leftOffset = leftOffset;
	this.$t.animate({
		'margin-left' : this.leftOffset + 'px'
	}, 150);
};

CurtainSlider.prototype.refreshControlArrows_ = function() {
	this.$left.removeClass('disabled');
	this.$right.removeClass('disabled');
};

CurtainSlider.prototype.disableControlArrow_ = function($arrow) {
	$arrow.addClass('disabled');
};


/**
 * decide, which methods will be "public"
 */
var API = {
	reinitSlider: CurtainSlider.prototype.reinitSlider
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new CurtainSlider(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.curtain-webslider.js